module.exports = __webpack_public_path__ + "img/home-bg.fcfe0450.jpg";